<template>
  <div class="page-team">
    <crm-panel :title="'团队管理'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.teamAdd && auth.teamAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="handleOpenAddTeam()"
        >
        </crm-button>
      </div>
      <div class="mt20">
        <el-form ref="form" :model="searchForm" :inline="true">
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <el-option label="用户名称" :value="1"></el-option>
                <el-option label="成员账号" :value="2"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="crmTeams.root ? [crmTeams.root] : []"
        height="100%"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        :expand-row-keys="expandKeys"
        v-loading="loading"
      >
        <el-table-column prop="name" label="团队名称" width="250">
        </el-table-column>
        <el-table-column prop="leaderUserName" align="center" label="负责人">
        </el-table-column>
        <el-table-column prop="remark" align="center" label="备注">
        </el-table-column>
        <el-table-column prop="gmtCreated" align="center" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.gmtCreated | formatTimeShow }}
          </template>
        </el-table-column>
        <el-table-column prop="gmtModified" align="center" label="修改时间">
          <template slot-scope="scope">
            {{ scope.row.gmtModified | formatTimeShow }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="280px">
          <template slot-scope="scope">
            <el-button
              @click="showAddMember(scope)"
              type="text"
              size="small"
              v-if="auth.teamAddUser && auth.teamAddUser.toggleStatus">新增成员</el-button>
            <el-button
              @click="goMemberList(scope)"
              type="text"
              size="small"
              v-if="auth.teamQueryUser && auth.teamQueryUser.toggleStatus">查看成员</el-button>
            <el-button
              @click="modifyTeam(scope)"
              type="text"
              size="small"
              v-if="auth.teamUpdate && auth.teamUpdate.toggleStatus">编辑</el-button>
            <el-button
              @click="deletTeam(scope)"
              type="text"
              size="small"
              v-if="auth.teamDelete && auth.teamDelete.toggleStatus">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </crm-panel>

    <!-- 查看团队成员侧面板 -->
    <team-member
      v-if="teamMemberVisible"
      :teamMemberKey="teamMemberKey"
      @handleCloseDetail="teamMemberVisible = false"
    >
    </team-member>

    <!-- 添加成员弹窗 -->
    <el-dialog
      title="添加成员"
      :visible.sync="isAddMemberVisible"
      :width="'500px'"
      @close="cancelAddDialogVisible"
    >
      <div class="dialog-body addmember-body">
        <el-form
          ref="addMemberForm"
          :rules="userListRules"
          :model="addMemberForm"
        >
          <el-form-item label="成员账号：" label-width="100px" prop="loginId">
            <!-- <el-input
              v-model="addMemberForm.loginId"
              auto-complete="off"
              placeholder="批量添加以,（英文逗号）区隔">
            </el-input> -->
            <el-select
              v-model="addMemberForm.loginId"
              multiple
              filterable
              remote
              collapse-tags
              placeholder="请输入登录账号或姓名"
              :remote-method="getUserList"
              :loading="userLoading"
            >
              <el-option
                v-for="item in userListOption"
                :key="item.userId"
                :label="`${item.loginId + ' ' + item.userName}`"
                :value="item.loginId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签：" label-width="100px" prop="teamLabel">
            <el-select v-model="addMemberForm.teamLabel">
              <el-option label="销售人员" :value="1"></el-option>
              <el-option label="非销售人员" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="cancelAddDialogVisible"
          >
          </crm-button>
          <crm-button :text="'确定'" @click="handleAddMember"></crm-button>
        </div>
      </div>
    </el-dialog>

    <!-- 新增团队弹窗 -->
    <add-edit-dialog v-if="isAddTeamVisible">
      <crm-panel title="新增团队">
        <div class="page-buttons">
          <crm-button :text="'保存'" @click="handleAddTeam()"> </crm-button>
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="handleCancelAddTeam()"
          >
          </crm-button>
        </div>
        <el-form class="add-edit-form">
          <el-col :span="12" :offset="5">
            <el-form-item
              label="团队名称："
              label-width="120px"
              :rules="{ required: true }"
            >
              <el-input v-model="addTeamForm.name" auto-complete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item
              label="上级团队："
              label-width="120px"
              :rules="{ required: true }"
            >
              <el-cascader
                class="parent-team"
                :options="parentTeamList"
                filterable
                @change="changeParentTeam"
                v-model="selectedTeamAdd"
                :props="{ checkStrictly: true }"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item label="负责人账号：" label-width="120px">
              <el-input v-model="addTeamForm.leaderLoginId" auto-complete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item
              label="备注："
              label-width="120px"
              :rules="{ required: true }"
            >
              <el-input
                type="textarea"
                v-model="addTeamForm.remark"
                :rows="4"
                :maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </crm-panel>
    </add-edit-dialog>

    <!-- 修改团队弹窗 -->
    <add-edit-dialog v-show="isModifyTeamVisible">
      <crm-panel title="修改团队">
        <div class="page-buttons">
          <crm-button :text="'保存'" @click="handleModifyTeam()"> </crm-button>
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="handleCancelModifyTeam()"
          >
          </crm-button>
        </div>
        <el-form class="add-edit-form">
          <el-col :span="12" :offset="5">
            <el-form-item
              label="团队名称："
              label-width="120px"
              :rules="{ required: true }"
            >
              <el-input v-model="modifyTeamForm.name" auto-complete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item
              label="上级团队："
              label-width="120px"
              :rules="{ required: true }"
            >
              <el-cascader
                class="parent-team"
                :options="parentTeamList"
                filterable
                @change="changeParentTeamEdit"
                v-model="selectedTeam"
                :props="{ checkStrictly: true }"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item label="负责人账号：" label-width="120px">
              <el-input
                v-model="modifyTeamForm.leaderLoginId"
                auto-complete="off"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item
              label="备注："
              label-width="120px"
              :rules="{ required: true }"
            >
              <el-input
                type="textarea"
                v-model="modifyTeamForm.remark"
                :rows="4"
                :maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </crm-panel>
    </add-edit-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import treeGrid from '@/scripts/treegrid';
import { formatTimeShow } from '@/scripts/utils';
import TreeGrid from '~component/business/backstage/treegrid.vue';
import TeamMember from '~component/business/backstage/TeamMember.vue';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import AddEditDialog from '@/components/base/addEditDialog';
import service from '~api/backstage';
import _ from 'lodash';

export default {
  components: {
    TreeGrid,
    TeamMember,
    crmPanel,
    crmButton,
    AddEditDialog,
  },
  data() {
    var validatorUser = (rule, value, callback) => {
      // if (this.flag === 0) return;
      if (value.length === 0) {
        callback(new Error('请输入登录账号或姓名以选择用户'));
      } else {
        callback();
      }
    };
    return {
      searchNameType: 1,
      searchName: '',
      loading: false,
      searchForm: {
        loginId: '',
        userName: '',
      },
      expandKeys: [],
      columns: [
        {
          text: '团队名称',
          dataIndex: 'name',
        },
        {
          text: '负责人',
          dataIndex: 'leaderUserName',
        },
        {
          text: '备注',
          dataIndex: 'remark',
        },
        {
          text: '创建时间',
          dataIndex: 'gmtCreated',
        },
        {
          text: '修改时间',
          dataIndex: 'gmtModified',
        },
      ],
      treegridData: [],
      isAddMemberVisible: false,
      isAddTeamVisible: false,
      isModifyTeamVisible: false,
      addMemberForm: {
        loginId: [],
        teamId: '',
        teamType: '',
        teamLabel: null,
      },
      selectedTeamAdd: [],
      addTeamForm: {
        parentTeamId: '',
        name: '',
        remark: '',
        leaderLoginId: '',
        teamType: '',
      },
      modifyTeamForm: {
        parentTeamId: '',
        name: '',
        remark: '',
        leaderLoginId: '',
        teamType: '',
        id: '',
      },
      selectedTeam: [],
      parentTeamList: [],
      chosenTeam: {},
      // 查看团队成员
      teamMemberVisible: false,
      teamMemberKey: {},
      userLoading: false,
      flag: 0,
      userListOption: [],
      userListRules: {
        loginId: [
          {
            required: true,
            validator: validatorUser,
            trigger: 'blur',
          },
          {
            required: true,
            message: '请输入登录账号或姓名以选择用户',
            trigger: 'change',
          },
        ],
        teamLabel: [
          {
            required: true,
            message: '请选择标签',
            trigger: 'change',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      crmTeams: 'backstage/crmTeams',
      parentTeams: 'backstage/parentTeams',
      backstageMenu: 'authority/backstageMenu',
      auth: 'authority/auth',
    }),
  },
  created() {
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      getTeamList: 'backstage/getTeamList',
      addTeamMember: 'backstage/addTeamMember',
      addTeam: 'backstage/addTeam',
      getParentTeamList: 'backstage/getParentTeamList',
      deleteTeam: 'backstage/deleteTeam',
      updateTeam: 'backstage/updateTeam',
    }),
    // eslint-disable-next-line
    getUserList: _.debounce(function(query) {
      if (!query) return;
      this.userLoading = true;
      service
        .apiQueryTeamUser({ searchKeyWord: query })
        .then((res) => {
          this.flag = this.flag + 1;
          this.userListOption = res.data.data || [];
        })
        .finally(() => {
          this.userLoading = false;
        });
    }, 400),
    handleSearch() {
      this.loading = true;
      this.searchForm.userName = null;
      this.searchForm.loginId = null;
      if (this.searchName) {
        if (this.searchNameType === 1) {
          this.searchForm.userName = this.searchName;
        } else if (this.searchNameType === 2) {
          this.searchForm.loginId = this.searchName;
        }
      }
      // 获取团队数据将树形数据转换为数组
      this.getTeamList(this.searchForm)
        .then(() => {
          if (!this.crmTeams.root) return;

          const data = treeGrid.treeToArray(
            [this.crmTeams.root],
            null,
            null,
            true,
          );
          this.treegridData = data;
          this.expandKeys = [
            '1',
            '69',
            '114',
            '117',
            '167',
            '121',
            '122',
            '118',
          ];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteEmptyChild(arr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length <= 0) {
          delete item.children;
        } else {
          this.deleteEmptyChild(item.children);
        }
      });
    },
    showAddMember(scope) {
      this.addMemberForm.teamId = scope.row.id;
      this.addMemberForm.teamType = scope.row.teamType;
      this.isAddMemberVisible = true;
    },
    handleAddMember() {
      this.$refs.addMemberForm.validate((valid) => {
        if (valid) {
          this.addTeamMember(this.addMemberForm).then(() => {
            this.$message({
              type: 'success',
              message: '添加成功',
            });
            this.isAddMemberVisible = false;
            this.addMemberForm.loginId = [];
            this.cancelAddDialogVisible();
          });
        }
      });
    },
    handleOpenAddTeam() {
      this.handleInitTreeData()
      this.isAddTeamVisible = true
    },
    handleCancelAddTeam() {
      this.addTeamForm = {
        parentTeamId: '',
        name: '',
        remark: '',
        leaderLoginId: '',
        teamType: '',
      };
      this.selectedTeamAdd = [];
      this.isAddTeamVisible = false;
    },
    cancelAddDialogVisible() {
      this.isAddMemberVisible = false;
      this.addMemberForm.loginId = [];
      this.addMemberForm.teamLabel = null;
      this.flag = 0;
      this.userLoading = false;
      this.userListOption = [];
      this.$refs.addMemberForm.resetFields();
    },
    handleAddTeam() {
      if (!this.addTeamForm.name) {
        this.$message({
          type: 'error',
          message: '请输入团队名称',
        });
      }
      if (!this.addTeamForm.parentTeamId) {
        this.$message({
          type: 'error',
          message: '请输入上级团队',
        });
      }
      this.addTeam(this.addTeamForm).then(() => {
        this.$message({
          type: 'success',
          message: '添加团队成功',
        });
        this.handleCancelAddTeam();
        this.handleSearch();
      });
    },
    changeParentTeam(team) {
      const teamId = team[team.length - 1];
      this.getChildTeam(this.parentTeamList, teamId);
      this.addTeamForm.parentTeamId = this.chosenTeam.value;
      this.addTeamForm.teamType = this.chosenTeam.teamType;
    },
    changeParentTeamEdit(team) {
      const teamId = team[team.length - 1];
      this.getChildTeam(this.parentTeamList, teamId);
      this.modifyTeamForm.parentTeamId = this.chosenTeam.value;
      this.modifyTeamForm.teamType = this.chosenTeam.teamType;
    },
    getChildTeam(arr, teamId) {
      arr.forEach((item) => {
        if (item.value === teamId) {
          this.chosenTeam = item;
        } else if (item.children && item.children.length > 0) {
          this.getChildTeam(item.children, teamId);
        }
      });
    },
    // 查看团队成员
    goMemberList(scope) {
      this.teamMemberVisible = true;
      this.teamMemberKey = scope.row;
    },
    deletTeam(scope) {
      this.$confirm(`确定删除${scope.row.name}团队？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.deleteTeam({
          id: scope.row.id,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.handleSearch();
        });
      });
    },
    async handleInitTreeData() {
      await this.getParentTeamList()
      this.parentTeamList = [this.parentTeams]
      this.deleteEmptyChild(this.parentTeamList)
    },
    async modifyTeam(scope) {
      this.handleInitTreeData()
      const { data } = await service.apiGetTeamDetail({ id: scope.row.id })
      const {
        id, parentTeamId, name, remark, leaderLoginId, teamType,
      } = data
      this.selectedTeam = parentTeamId
      this.modifyTeamForm.id = id
      this.modifyTeamForm.parentTeamId = parentTeamId
      this.modifyTeamForm.name = name
      this.modifyTeamForm.remark = remark
      this.modifyTeamForm.leaderLoginId = leaderLoginId
      this.modifyTeamForm.teamType = teamType
      this.isModifyTeamVisible = true;
    },
    handleCancelModifyTeam() {
      this.addTeamForm = {
        parentTeamId: '',
        name: '',
        remark: '',
        leaderLoginId: '',
        teamType: '',
        id: '',
      };
      this.selectedTeam = [];
      this.isModifyTeamVisible = false;
    },
    handleModifyTeam() {
      if (!this.modifyTeamForm.name) {
        this.$message({
          type: 'error',
          message: '请输入团队名称',
        });
      }
      if (!this.modifyTeamForm.parentTeamId) {
        this.$message({
          type: 'error',
          message: '请输入上级团队',
        });
      }
      this.updateTeam(this.modifyTeamForm).then(() => {
        this.$message({
          type: 'success',
          message: '团队修改成功',
        });
        this.isModifyTeamVisible = false;
        this.modifyTeamForm = {
          parentTeamId: '',
          name: '',
          remark: '',
          leaderLoginId: '',
          teamType: '',
          id: '',
        };
        this.handleSearch();
      });
    },
  },
  filters: {
    formatTimeShow,
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';

.page-team {
  display: flex;
  flex: 1;
  width: 100%;
  .el-table {
    margin-bottom: 20px;
  }
  .dialog-body {
    padding-right: 20px;
  }
  .addmember-body {
    .el-select {
      width: 100%;
    }
  }
  .dialog-footer {
    text-align: right;
  }
  .parent-team {
    width: 100%;
  }
}
</style>
